import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { makeStyles } from '@mui/styles';
import sections from 'src/styles/sections';
import { palette } from '@livable/saas-react-components';
import breakpointsFunc from 'src/styles/breakpointsFunc';
const useStyles = makeStyles(_objectSpread(_objectSpread({}, sections), {}, {
  createFormContainer: {
    padding: '0px 36px',
    height: '350px',
    overflow: 'scroll'
  },
  createFormHeader: {
    marginBottom: '24px'
  },
  radioItemWrapper: {
    padding: '12px 0'
  },
  radioItem: {
    paddingLeft: '32px'
  },
  radioItemGeneralSpacing: {
    marginTop: '16px'
  },
  credentialsInfo: {},
  credentialsInput: {
    width: '49%',
    '&:first-child': {
      marginRight: '2%'
    }
  },
  securityQuestionsInput: {
    width: '49%',
    '&:first-child': {
      marginRight: '2%'
    }
  },
  securityQuestionsInputAnswer: {
    width: 'calc(49% - 60px)'
  },
  securityQuestionsDeleteBtn: {
    marginLeft: '10px'
  },
  billFrequencySection: {
    marginBottom: '24px'
  },
  detailsPreviewRow: {
    display: 'flex',
    justifyContent: 'flex-start',
    width: '100%',
    paddingBottom: '8px'
  },
  detailsPreviewTitle: {
    marginRight: '10px',
    width: '31%'
  },
  detailsPreviewValue: {
    width: '69%'
  },
  detailsPreviewActions: {
    // height: '16px',
    '& .MuiButton-actionButton': {
      marginLeft: '10px',
      marginTop: '16px'
    }
  },
  detailsPreviewStatusChip: {
    '& .MuiChip-root': {
      maxHeight: '20px'
    }
  },
  detailsPreviewShowProtectedData: {
    marginLeft: '6px'
  },
  modalFooterAlert: {
    bottom: '0',
    position: 'relative',
    '& .MuiPaper-root': {
      padding: '12px 40px'
    }
  },
  modalFooter: {
    padding: '32px 40px',
    borderTop: "1px solid ".concat(palette.shades[400])
  },
  footerEven: {
    display: 'flex',
    justifyContent: 'space-between',
    [breakpointsFunc.breakpoints.down('sm')]: {
      flexDirection: 'column-reverse'
    }
  },
  footerButton: {
    display: 'inline-block',
    '& + &': {
      marginLeft: '10px'
    },
    [breakpointsFunc.breakpoints.down('sm')]: {
      width: '100%',
      '& + &': {
        marginTop: '10px',
        marginLeft: '0'
      },
      '& button': {
        width: '100%'
      }
    }
  },
  footerWrapper: {
    display: 'flex',
    [breakpointsFunc.breakpoints.down('sm')]: {
      flexDirection: 'column',
      '& + &': {
        marginBottom: '10px'
      }
    }
  },
  rightButton: {
    '& + &': {
      marginLeft: '10px'
    }
  }
}));
export default useStyles;